var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsdt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3788 3.10047C7.7787 2.85603 9.61084 2.75 12 2.75C14.3892 2.75 16.2213 2.85603 17.6212 3.10047C19.0155 3.34393 20.0594 3.73726 20.8007 4.37278C21.5652 5.02825 21.9215 5.8658 22.0898 6.80368C22.2501 7.69713 22.25 8.7505 22.25 9.89536V9.94867C22.25 10.3629 21.9142 10.6987 21.5 10.6987C21.0351 10.6987 20.7394 10.8679 20.551 11.0833C20.3497 11.3134 20.2319 11.6434 20.2319 11.9995C20.2319 12.3557 20.3497 12.6856 20.551 12.9157C20.7394 13.1311 21.0351 13.3004 21.5 13.3004C21.9142 13.3004 22.25 13.6362 22.25 14.0504V14.1037C22.25 15.2488 22.2501 16.3023 22.0898 17.1959C21.9215 18.1339 21.5652 18.9715 20.8007 19.6271C20.0594 20.2627 19.0155 20.656 17.6212 20.8995C16.2213 21.144 14.3892 21.25 12 21.25C9.61084 21.25 7.77869 21.144 6.3788 20.8995C4.98453 20.656 3.94057 20.2627 3.19931 19.6271C2.43479 18.9715 2.07849 18.1339 1.91022 17.1959C1.74993 16.3023 1.74996 15.2488 1.75 14.1037L1.75 14.0504C1.75 13.6362 2.08579 13.3004 2.5 13.3004C2.96491 13.3004 3.26062 13.1311 3.44902 12.9157C3.65027 12.6856 3.76806 12.3557 3.76806 11.9995C3.76806 11.6434 3.65027 11.3134 3.44902 11.0833C3.26062 10.8679 2.96491 10.6987 2.5 10.6987C2.08579 10.6987 1.75 10.3629 1.75 9.94867L1.75 9.89536C1.74996 8.7505 1.74993 7.69713 1.91023 6.80368C2.0785 5.8658 2.43482 5.02825 3.19934 4.37278C3.9406 3.73726 4.98454 3.34393 6.3788 3.10047ZM3.25116 9.28919C3.79092 9.42559 4.24022 9.70953 4.57807 10.0958C5.0495 10.6348 5.26806 11.3302 5.26806 11.9995C5.26806 12.6688 5.0495 13.3643 4.57807 13.9033C4.24022 14.2895 3.79092 14.5735 3.25116 14.7099C3.25572 15.6053 3.27803 16.3255 3.38666 16.931C3.51527 17.648 3.75271 18.1257 4.1757 18.4884C4.62193 18.871 5.35923 19.1988 6.63683 19.4219C7.90881 19.644 9.63916 19.75 12 19.75C14.3608 19.75 16.0912 19.644 17.3632 19.4219C18.6408 19.1988 19.3781 18.871 19.8243 18.4884C20.2473 18.1257 20.4847 17.648 20.6133 16.931C20.722 16.3255 20.7443 15.6053 20.7488 14.7099C20.2091 14.5735 19.7598 14.2895 19.4219 13.9033C18.9505 13.3643 18.7319 12.6688 18.7319 11.9995C18.7319 11.3302 18.9505 10.6348 19.4219 10.0958C19.7598 9.70953 20.2091 9.4256 20.7488 9.2892C20.7443 8.39396 20.722 7.67398 20.6133 7.06857C20.4847 6.35178 20.2473 5.87419 19.8243 5.51155C19.3781 5.12896 18.6408 4.80121 17.3632 4.57811C16.0912 4.356 14.3608 4.25 12 4.25C9.63916 4.25 7.90881 4.356 6.63683 4.57811C5.35921 4.80121 4.62191 5.12896 4.17567 5.51155C3.75269 5.87419 3.51526 6.35178 3.38665 7.06857C3.27803 7.67397 3.25572 8.39396 3.25116 9.28919Z",
    fill: "url(#paint0_linear_759_949)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.368 10.592H10.024V9.8H13.684V10.592H12.34V14H11.368V10.592Z",
    fill: "url(#paint1_linear_759_949)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_759_949",
    x1: 1.75,
    y1: 12,
    x2: 13.9122,
    y2: 1.92994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3364E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333DC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_759_949",
    x1: 10,
    y1: 11.5,
    x2: 13.3832,
    y2: 10.0555,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.104167,
    stopColor: "#3364E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#333DC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsdt);
export default __webpack_public_path__ + "static/media/USDT.77d47f8ed522645cb0daab0b6f98eca3.svg";
export { ForwardRef as ReactComponent };